import { defaultThemes } from "react-data-table-component";

const tableStyleDefaulInternal: any = {
  table: {},

  header: {
    style: {
      height: "55px",
      fontWeight: "bold",
    },
  },
  headRow: {
    style: {
      color: "black",
      borderStyle: "solid",
      fontWeight: "bold",
      borderWidth: "1px",
      borderColor: defaultThemes.default.divider.default,
      backgroundColor: "#D8D8D8",
      fontSize: "11px",
      height: "55px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
        borderRightColor: defaultThemes.default.divider.default,
        height: "55px",
      },
    },
  },
  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
        borderRightColor: defaultThemes.default.divider.default,
        textTransform: "capitalize",
        fontSize: "11px",
        height: "55px",
      },
    },
  },
  rows: {
    style: {
      borderStyle: "solid",
      borderWidth: "1px",
      borderColor: defaultThemes.default.divider.default,
      fontSize: "11px",
      textTransform: "capitalize",
      borderTopStyle: "none",
      "&:hover": {
        backgroundColor: "#E0F7FA",
      },
      height: "55px",
    },
  },
};

export default tableStyleDefaulInternal;
